// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import actions from './actions'
import Confirmation from './Confirmation'
import { push } from 'connected-react-router'
import constants from './constants'
import { actions as Balance } from '../Balance'

const mapStateToProps = ({ confirmation, pointsPurchase: { config: { packageSize } } }, ownProps) => {
  return {
    order: confirmation,
    orderId: ownProps.match.params.orderId,
    packageSize
  }
}

const mapDispatchToProps = dispatch => ({
  redirectNotFoundPage: () => {
    dispatch(push(constants.REDIRECT_ROUTE_PAGE_404))
  },
  getOrder: orderId => dispatch(actions.getOrder(orderId)),
  redirect: path => dispatch(push(path)),
  loadBalance: () => dispatch(Balance.loadBalance())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation)



// WEBPACK FOOTER //
// ./src/features/Confirmation/ConfirmationContainer.js